import React, { useState } from "react";
import {
  Box,
  Typography,
  Alert,
  Paper,
  Tab,
  Tabs,
  styled,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import AddIcon from "@mui/icons-material/Add";
import {
  useGetCapabilitiesQuery,
  useProductQuery,
  useSaveCapabilityMutation,
} from "../../useQuery";
import useAddAppDetails from "../../useQuery/useAddAppDetails";
import { PageTitle, IconContainer } from "../../components-new/common";
import { useLocation } from "react-router-dom";
import CapabilitiesManager from "./CapabilitiesManager";
import AppVersionManager from "./AppVersionManager";

const StyledCard = styled(Paper)(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0px 43px 62.4px 0px rgba(0, 0, 0, 0.09)",
  borderTop: "2px solid #2550d1",
  overflow: "hidden",
}));

const MobileConfiguration = () => {
  const path = useLocation().pathname;


  const [activeTab, setActiveTab] = useState(0);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");


  const { data: products } = useProductQuery();
  const { data: savedCapabilities, refetch: refetchCapabilities } = useGetCapabilitiesQuery();
  const saveCapabilityMutation = useSaveCapabilityMutation({
    onSuccess: (data) => {
      refetchCapabilities();
      setSuccess("Capability saved successfully!");
      setError("");
      setTimeout(() => setSuccess(""), 3000);
    },
    onError: (error) => {
      setError("Failed to save capability: " + (error.message || "Unknown error"));
    },
  });


  const addAppDetailsMutation = useAddAppDetails({
    onSuccess: (data) => {
      setSuccess("App version created successfully!");
      setError("");
      setTimeout(() => setSuccess(""), 3000);
    },
    onError: (error) => {
      setError("Failed to create app version: " + (error.message || "Unknown error"));
    },
  });


  const handleSaveCapability = async (capabilityData) => {
    await saveCapabilityMutation.mutateAsync(capabilityData);
  };

  const handleCreateAppVersion = async (appVersionData) => {
    await addAppDetailsMutation.mutateAsync(appVersionData);
  };

  const handleError = (errorMessage) => {
    setError(errorMessage);
    setTimeout(() => setError(""), 3000);
  };

  const handleSuccess = (successMessage) => {
    setSuccess(successMessage);
    setTimeout(() => setSuccess(""), 3000);
  };

  return (
    <Box sx={{ py: 4 }}>



      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => setActiveTab(newValue)}
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: 500,
              py: 2,
            },
            "& .Mui-selected": { color: "#2550d1" },
            "& .MuiTabs-indicator": { backgroundColor: "#2550d1", height: 3 },
          }}
        >
          <Tab label="Device Capabilities" icon={<SettingsIcon />} iconPosition="start" />
          <Tab label="App Versions" icon={<AddIcon />} iconPosition="start" />
        </Tabs>
      </Box>


      {activeTab === 0 && (
        <StyledCard>
          <Box sx={{ p: 3 }}>
            <CapabilitiesManager
              savedCapabilities={savedCapabilities || []}
              onSaveCapability={handleSaveCapability}
              onError={handleError}
              onSuccess={handleSuccess}
              isSaving={saveCapabilityMutation.isPending}
            />
          </Box>
        </StyledCard>
      )}

      {activeTab === 1 && (
        <StyledCard>
          <Box sx={{ p: 3 }}>
            <AppVersionManager
              products={products || []}
              onCreateAppVersion={handleCreateAppVersion}
              onError={handleError}
              onSuccess={handleSuccess}
              isCreating={addAppDetailsMutation.isPending}
            />
          </Box>
        </StyledCard>
      )}


      {error && (
        <Alert
          severity="error"
          sx={{
            mt: 3,
            borderRadius: "10px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          }}
          onClose={() => setError("")}
          variant="filled"
        >
          {error}
        </Alert>
      )}


      {success && (
        <Alert
          severity="success"
          sx={{
            mt: 3,
            borderRadius: "10px",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          }}
          onClose={() => setSuccess("")}
          variant="filled"
        >
          {success}
        </Alert>
      )}
    </Box>
  );
};

export default MobileConfiguration; 